import errorIcon from "assets/images/Error 404.png";
import { Image, Logo } from "components";
import { config } from "constant";
import { DownloadBox } from "containers";

export default function Error404() {
  return (
    <section className="w-full min-h-[100svh] flex flex-col">
      <div className="w-full m-auto flex flex-col items-center text-center py-10 px-5">
        <Logo variant="logo-text-col-2" className="w-32" />
        <Image src={errorIcon} alt={config.title} className="w-56 mt-16" />
        <p className="text-lg text-[#5E6278] font-semibold mt-5">
          The followed page doesn't exist anymore
        </p>
        <p className="text-sm text-[#5E6278] font-medium mt-2.5">
          Followed page doesn't exist anymore. Maybe the owner deleted their
          content. Please try something else.
        </p>
        <DownloadBox className="mt-12" />
      </div>
    </section>
  );
}
